var lib = require('./lib');

module.exports = lib.default;



//////////////////
// WEBPACK FOOTER
// ../flow-runtime-mobx/flow-runtime-mobx.js
// module id = 126
// module chunks = 0